<template>
  <div class="uk-card-body">
    <div class="uk-grid" v-if="!showBrokerFields">
      <div class="uk-width-1-3">
        <label for="ship line" class="uk-form-label">Steamship Line</label>

        <FilterableDropdown
          taggable
          push-tag
          v-model="orderData.shipLineInfo.line"
          :options="steamshipLines"
          :components="{ OpenIndicator: null, Deselect: null }"
        ></FilterableDropdown>
      </div>
      <div class="uk-width-1-3">
        <label for="blNumber" class="uk-form-label">Vessel Name</label>
        <FilterableDropdown
          taggable
          push-tag
          v-model="orderData.shipLineInfo.vessel"
          :options="filteredVessels"
          :components="{ OpenIndicator: null, Deselect: null }"
        ></FilterableDropdown>
      </div>
      <div>
        <label v-if="isOceanImport" for="eta" class="uk-form-label">ETA</label>
        <label v-else for="eta" class="uk-form-label">Vessel Cut Off/LRD</label>
        <DatePicker
          class="uk-form-label"
          :input-class="'uk-input uk-width-medium'"
          format="MM/DD/YYYY"
          @input="changedETA"
        ></DatePicker>
      </div>
    </div>
    <div class="uk-grid" v-if="showBrokerFields">
      <div class="uk-width-1-4">
        <InputField
          label="Port of Loading"
          v-model="orderData.brokerSailingInfo.portOfLoading"
        >
        </InputField>
      </div>
      <div class="uk-width-1-4">
        <InputField
          label="Port of Discharge"
          v-model="orderData.brokerSailingInfo.portOfDischarge"
        >
        </InputField>
      </div>
      <div class="uk-width-1-4">
        <InputField
          label="Place of Receipt"
          v-model="orderData.brokerSailingInfo.placeOfReceipt"
        >
        </InputField>
      </div>
      <div class="uk-width-1-4">
        <InputField
          label="Place of Delivery"
          v-model="orderData.brokerSailingInfo.placeOfDelivery"
        >
        </InputField>
      </div>
    </div>
    <div class="uk-grid uk-margin-small-top" v-if="showBrokerFields">
      <div class="uk-width-1-3">
        <InputField
          label="Vessel/Voyage"
          v-model="orderData.brokerSailingInfo.vesselVoyage"
        >
        </InputField>
      </div>
      <div class="uk-width-1-3">
        <InputField
          label="Sailing Date"
          v-model="orderData.brokerSailingInfo.sailingDate"
        >
        </InputField>
      </div>
      <div class="uk-width-1-3">
        <InputField
          label="Arrival Date"
          v-model="orderData.brokerSailingInfo.arrivalDate"
        >
        </InputField>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VesselsQuery from '@/gql/orders/Vessels.gql';
import DatePicker from '@/components/core/DateTime/DatePicker.vue';
import FilterableDropdown from '../../core/FilterableDropdown.vue';
import { SteamShipLinesMap, SteamShipLines } from '../../../utils/constants';
import { orderTypeMixin } from '../../../utils/order';
import { NewOrderData } from './orderData';

export default defineComponent({
  data() {
    return { steamshipLines: SteamShipLines };
  },
  mixins: [orderTypeMixin],
  components: {
    DatePicker,
    FilterableDropdown,
  },
  props: {
    orderData: {
      required: true,
    },
    showBrokerFields: {
      default: false,
    },
  },
  computed: {
    orderType() {
      return ((this as any).orderData as NewOrderData).orderType;
    },
    filteredVessels(): any[] {
      if (!(this as any).vessels) {
        return [];
      }

      return (this as any).vessels
        .filter(
          (v, i, a) => v.name && a.findIndex((t) => t.name === v.name) === i,
        )
        .map((x) => x.name);
    },
  },
  apollo: {
    vessels: {
      query: VesselsQuery,
    },
  },
});
</script>